export const RESOURCE_BASE_PATH = '/resource';

export const RECRUIT_BASE_PATH = '/recruit';
export const SALES_MATERIAL_BASE_PATH = '/sales-material';
export const PROMOTION_MATERIAL_BASE_PATH = '/promotion-material';
export const HAPPY_SHARE_MATERIAL_BASE_PATH = '/happy-share-material';
export const HAPPY_SHARE_BASE_PATH = '/happy-share';
export const HAPPY_SHARE_COLUMN_BASE_PATH = '/column';

export const RECRUIT_LIBRARY_BASE_PATH = '/library';
export const HAPPY_SHARE_LIBRARY_BASE_PATH = '/library';
export const RECRUIT_CATEGORY_BASE_PATH = '/category';
export const RECRUIT_COLUMN_BASE_PATH = '/column';
export const HAPPY_SHARE_CATEGORY_BASE_PATH = '/category';
export const SALES_LIBRARY_BASE_PATH = '/library';
export const SALES_CATEGORY_BASE_PATH = '/category';
export const SALES_COLUMN_BASE_PATH = '/column';
export const RESOURCE_HAPPY_SHARE_TITLE = 'title.resource.happy.share';
export const RESOURCE_HAPPY_SHARE_LIBRARY_TITLE = 'title.resource.happy.share.library';
export const RESOURCE_HAPPY_SHARE_CATEGORY_TITLE = 'title.resource.happy.share.category';
export const RESOURCE_HAPPY_SHARE_COLUMN_TITLE = 'title.resource.happy.share.column';


export const PROMOTION_LIBRARY_BASE_PATH = '/library';
export const PROMOTION_CATEGORY_BASE_PATH = '/category';
export const PROMOTION_COLUMN_BASE_PATH = '/column';

//  These constants map to aside menu, header menu to display title
export const RESOURCE_TITLE = "title.resource";
export const RESOURCE_RECRUIT_TITLE = "title.resource.recruit";
export const RESOURCE_RECRUIT_LIBRARY_TITLE = "title.resource.recruit.library";
export const RESOURCE_RECRUIT_CATEGORY_TITLE = "title.resource.recruit.category";
export const RESOURCE_RECRUIT_COLUMN_TITLE = "title.resource.recruit.column";
export const RESOURCE_SALES_TITLE = "title.resource.sales";
export const RESOURCE_SALES_LIBRARY_TITLE = "title.resource.sales.library";
export const RESOURCE_SALES_CATEGORY_TITLE = "title.resource.sales.category";
export const RESOURCE_SALES_COLUMN_TITLE = "title.resource.sales.column";
export const RESOURCE_PROMOTION_TITLE = "title.resource.promotion";
export const RESOURCE_PROMOTION_LIBRARY_TITLE = "title.resource.promotion.library";
export const RESOURCE_PROMOTION_CATEGORY_TITLE = "title.resource.promotion.category";
export const RESOURCE_PROMOTION_COLUMN_TITLE = "title.resource.promotion.column";

//  These constants map to permission control, identical to permission enum defined below
export const RESOURCE_RECRUIT_LIBRARY_NAMESPACE = "RESOURCE-RECRUIT-LIBRARY";
export const RESOURCE_RECRUIT_CATEGORY_NAMESPACE = "RESOURCE-RECRUIT-CATEGORY";
export const RESOURCE_RECRUIT_COLUMN_NAMESPACE = "RESOURCE-RECRUIT-COLUMN";
export const RESOURCE_SALES_LIBRARY_NAMESPACE = "RESOURCE-SALES-LIBRARY";
export const RESOURCE_SALES_CATEGORY_NAMESPACE = "RESOURCE-SALES-CATEGORY";
export const RESOURCE_SALES_COLUMN_NAMESPACE = "RESOURCE-SALES-COLUMN";
export const RESOURCE_PROMOTION_LIBRARY_NAMESPACE = "RESOURCE-PROMOTION-LIBRARY";
export const RESOURCE_PROMOTION_CATEGORY_NAMESPACE = "RESOURCE-PROMOTION-CATEGORY";
export const RESOURCE_PROMOTION_COLUMN_NAMESPACE = "RESOURCE-PROMOTION-COLUMN";
export const RESOURCE_HAPPY_SHARE_LIBRARY_NAMESPACE = 'RESOURCE-HAPPY-SHARE-LIBRARY';
export const RESOURCE_HAPPY_SHARE_CATEGORY_NAMESPACE = 'RESOURCE-HAPPY-SHARE-CATEGORY';
export const RESOURCE_HAPPY_SHARE_COLUMN_NAMESPACE = 'RESOURCE-HAPPY-SHARE-COLUMN';

export enum AdminResourcePermissionType {
  RESOURCE_RECRUIT_LIBRARY_READ = "READ_ANY_RESOURCE-RECRUIT-LIBRARY",
  RESOURCE_RECRUIT_LIBRARY_CREATE = "CREATE_ANY_RESOURCE-RECRUIT-LIBRARY",
  RESOURCE_RECRUIT_LIBRARY_UPDATE = "UPDATE_ANY_RESOURCE-RECRUIT-LIBRARY",

  RESOURCE_RECRUIT_CATEGORY_READ = "READ_ANY_RESOURCE-RECRUIT-CATEGORY",
  RESOURCE_RECRUIT_CATEGORY_CREATE = "CREATE_ANY_RESOURCE-RECRUIT-CATEGORY",
  RESOURCE_RECRUIT_CATEGORY_UPDATE = "UPDATE_ANY_RESOURCE-RECRUIT-CATEGORY",

  RESOURCE_RECRUIT_COLUMN_READ = "READ_ANY_RESOURCE-RECRUIT-COLUMN",
  RESOURCE_RECRUIT_COLUMN_CREATE = "CREATE_ANY_RESOURCE-RECRUIT-COLUMN",
  RESOURCE_RECRUIT_COLUMN_UPDATE = "UPDATE_ANY_RESOURCE-RECRUIT-COLUMN",

  RESOURCE_SALES_LIBRARY_READ = "READ_ANY_RESOURCE-SALES-LIBRARY",
  RESOURCE_SALES_LIBRARY_CREATE = "CREATE_ANY_RESOURCE-SALES-LIBRARY",
  RESOURCE_SALES_LIBRARY_UPDATE = "UPDATE_ANY_RESOURCE-SALES-LIBRARY",

  RESOURCE_SALES_CATEGORY_READ = "READ_ANY_RESOURCE-SALES-CATEGORY",
  RESOURCE_SALES_CATEGORY_CREATE = "CREATE_ANY_RESOURCE-SALES-CATEGORY",
  RESOURCE_SALES_CATEGORY_UPDATE = "UPDATE_ANY_RESOURCE-SALES-CATEGORY",

  RESOURCE_SALES_COLUMN_READ = "READ_ANY_RESOURCE-SALES-COLUMN",
  RESOURCE_SALES_COLUMN_CREATE = "CREATE_ANY_RESOURCE-SALES-COLUMN",
  RESOURCE_SALES_COLUMN_UPDATE = "UPDATE_ANY_RESOURCE-SALES-COLUMN",

  // PROMOTION
  RESOURCE_PROMOTION_LIBRARY_READ = "READ_ANY_RESOURCE-PROMOTION-LIBRARY",
  RESOURCE_PROMOTION_LIBRARY_CREATE = "CREATE_ANY_RESOURCE-PROMOTION-LIBRARY",
  RESOURCE_PROMOTION_LIBRARY_UPDATE = "UPDATE_ANY_RESOURCE-PROMOTION-LIBRARY",

  RESOURCE_PROMOTION_CATEGORY_READ = "READ_ANY_RESOURCE-PROMOTION-CATEGORY",
  RESOURCE_PROMOTION_CATEGORY_CREATE = "CREATE_ANY_RESOURCE-PROMOTION-CATEGORY",
  RESOURCE_PROMOTION_CATEGORY_UPDATE = "UPDATE_ANY_RESOURCE-PROMOTION-CATEGORY",

  RESOURCE_PROMOTION_COLUMN_READ = "READ_ANY_RESOURCE-PROMOTION-COLUMN",
  RESOURCE_PROMOTION_COLUMN_CREATE = "CREATE_ANY_RESOURCE-PROMOTION-COLUMN",
  RESOURCE_PROMOTION_COLUMN_UPDATE = "UPDATE_ANY_RESOURCE-PROMOTION-COLUMN",

  // HAPPY_SHARE
  RESOURCE_HAPPY_SHARE_LIBRARY_READ = 'READ_ANY_RESOURCE-HAPPY-SHARE-LIBRARY',
  RESOURCE_HAPPY_SHARE_LIBRARY_CREATE = 'CREATE_ANY_RESOURCE-HAPPY-SHARE-LIBRARY',
  RESOURCE_HAPPY_SHARE_LIBRARY_UPDATE = 'UPDATE_ANY_RESOURCE-HAPPY-SHARE-LIBRARY',

  RESOURCE_HAPPY_SHARE_CATEGORY_READ = 'READ_ANY_RESOURCE-HAPPY-SHARE-CATEGORY',
  RESOURCE_HAPPY_SHARE_CATEGORY_CREATE = 'CREATE_ANY_RESOURCE-HAPPY-SHARE-CATEGORY',
  RESOURCE_HAPPY_SHARE_CATEGORY_UPDATE = 'UPDATE_ANY_RESOURCE-HAPPY-SHARE-CATEGORY',

  RESOURCE_HAPPY_SHARE_COLUMN_READ = 'READ_ANY_RESOURCE-HAPPY-SHARE-COLUMN',
  RESOURCE_HAPPY_SHARE_COLUMN_CREATE = 'CREATE_ANY_RESOURCE-HAPPY-SHARE-COLUMN',
  RESOURCE_HAPPY_SHARE_COLUMN_UPDATE = 'UPDATE_ANY_RESOURCE-HAPPY-SHARE-COLUMN',

};